type Page =
  | "dashboard"
  | "profile"
  | "budget"
  | "portfolio"
  | "property-detail"
  | "loans"
  | "transfers"
  | "simulator"
  | "strategy"
  | "reports"
  | "tax"
  | "billing"
  | "settings"
  | "admin";

const ADMIN_EMAIL = "anguswilliams76@gmail.com";

export default function Sidebar({
  current,
  setCurrent,
  adminEmail,
  setupComplete,
}: {
  current: Page;
  setCurrent: (p: Page) => void;
  adminEmail?: string;
  setupComplete?: { profile: boolean; portfolio: boolean; loans: boolean; budget: boolean };
}) {
  const items: { id: Page; label: string; setupKey?: keyof NonNullable<typeof setupComplete> }[] = [
    { id: "dashboard", label: "Dashboard" },
    { id: "profile", label: "My Profile", setupKey: "profile" },
    { id: "budget", label: "Personal Budget", setupKey: "budget" },
    { id: "portfolio", label: "Portfolio", setupKey: "portfolio" },
    { id: "loans", label: "Loans", setupKey: "loans" },
    { id: "transfers", label: "Cashflow & Transfers" },
    { id: "simulator", label: "Simulator" },
    { id: "strategy", label: "Strategy" },
    { id: "reports", label: "Reports" },
    { id: "tax", label: "Tax" },
    { id: "billing", label: "Billing" },
    { id: "settings", label: "Settings" },
  ];

  const isAdmin = adminEmail === ADMIN_EMAIL;

  return (
    <div className="hidden md:flex flex-col w-48 lg:w-56 xl:w-64 bg-[#0F1117] border-r border-white/10 p-6">
      <div className="text-xl font-semibold text-[#C47A2F] pb-4 mb-4 border-b border-white/10">AusProp</div>

      <div className="space-y-0.5 flex-1">
        {items.map((item) => {
          const needsSetup =
            setupComplete && item.setupKey && !setupComplete[item.setupKey];
          return (
            <button
              key={item.id}
              onClick={() => setCurrent(item.id)}
              className={`w-full text-left px-4 py-2.5 rounded-xl transition-colors text-sm flex items-center justify-between ${
                current === item.id
                  ? "border-l-2 border-[#C47A2F] bg-[#C47A2F]/20 text-white font-semibold pl-[14px]"
                  : "text-[#9CA3AF] hover:bg-white/5 hover:text-white"
              }`}
            >
              <span>{item.label}</span>
              {needsSetup && (
                <span className="inline-block w-2 h-2 rounded-full bg-[#C47A2F] animate-pulse flex-shrink-0" />
              )}
            </button>
          );
        })}
      </div>

      {isAdmin && (
        <div className="mt-4 pt-4 border-t border-white/10">
          <button
            onClick={() => setCurrent("admin")}
            className={`w-full text-left px-4 py-2 rounded-xl transition-colors text-xs ${
              current === "admin"
                ? "border-l-2 border-[#C47A2F] bg-[#C47A2F]/20 text-white font-semibold pl-[14px]"
                : "text-[#9CA3AF] hover:bg-white/5 hover:text-white"
            }`}
          >
            🛡 Admin
          </button>
        </div>
      )}
    </div>
  );
}
